import React from 'react';
import { Copy } from 'lucide-react';
import { Button } from './ui/button';

export default function RoutePreviewChip({ url }) {
  if (!url) return null;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(`POST ${url}`);
  };

  return (
    <div className="rounded-md border bg-gray-50 p-3 text-xs flex items-center justify-between gap-2">
      <code className="break-all">POST {url}</code>
      <Button type="button" size="sm" variant="ghost" onClick={handleCopy} aria-label="Copy route">
        <Copy className="h-4 w-4" />
      </Button>
    </div>
  );
}
